import React from 'react';
import ModalFrame from '../../ModalFrame';
import EmbedCreate from './EmbedCreate';
import $ from 'jquery';

class EmbedCreateController extends React.Component {
  constructor(props) {
    super(props);
    this.hideModal = this.hideModal.bind(this);
    this.modalWidth = $(".example-modal").width();

  }


  hideModal() {
    const {setModalInfo} = this.props;
    setModalInfo({});
  }

  render() {
    const {modalInfo, confirmHandler, cancelHandler} = this.props;
    return (
      <div className="example-modal">
        {modalInfo.name === 'anonEmbedCreate' ?
          <ModalFrame
            title='PLACE A LINK TO YOUR OWN SURVEY ON YOUR WEBSITE'
            desktopWidth="60%"
            headerCloseButtonHandler={this.hideModal}
            hasHeader={true}>

            <EmbedCreate
              modalInfo={modalInfo}
              hideModal={this.hideModal}
              confirmHandler={confirmHandler}
              cancelHandler={cancelHandler}
            />
          </ModalFrame> : null}
      </div>
    )
  }
}

export default EmbedCreateController;